import api from "../../api";
import { getCorporateIdFromToken } from "@/utils/corporate";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    BusType: [],
    BusTypeLayout: [],
  },
  getters: {
    getBusType(state) {
      return state.BusType;
    },
    getBusTypeLayout(state) {
      return state.BusTypeLayout;
    },
  },
  mutations: {
    SetBusType(state, data) {
      state.BusType = [];
      state.BusType = data;
    },
    SetBusTypeLayout(state, data) {
      state.BusTypeLayout = [];
      state.BusTypeLayout = data;
    },
  },
  actions: {
    fetchAllBusType({ commit }, payload = {}) {
      return new Promise((resolve, rej) => {
        let corporateId = payload && (payload.corporateId || payload.CorporateId);
        if (!corporateId) {
          corporateId = getCorporateIdFromToken();
        }
        const body = corporateId ? { corporateId: corporateId } : {};
        api()
          .post(`BusType/get_all_bus_types`, body, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
            commit("SetBusType", res.data);
          })
          .catch((err) => console.log(err));
      });
    },
    fetchBusTypeById({ commit }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `BusType/get_bus_types_by_id`,
            {
              id: id,
            },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
            commit("SetBusType", res.data);
          })
          .catch((err) => console.log(err));
      });
    },
    getBusTypesBySeats({ commit }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`BusType/getBusTypesBySeats`, data, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
            commit("SetBusType", res.data);
          })
          .catch((err) => console.log(err));
      });
    },
    addBusType({ dispatch }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`BusType/add_bus_type`, data, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    editBusType({ dispatch }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`BusType/edite_bus_type`, data, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    deleteBusType({ dispatch }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `BusType/delete_bus_type`,
            { id: id },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    fetchBusTypeLayout({ commit }, busTypeId) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `/BusTypeLayout/getBusTypeLayout`,
            { busTypeId: busTypeId },
            { headers: { Authorization: localStorage.getItem("JwtToken") } }
          )
          .then((res) => {
            resolve(res);
            commit("SetBusTypeLayout", res.data.busTypeLayout);
          })
          .catch((err) => console.log(err));
      });
    },
    updateBusTypeLayout({ dispatch }, { busTypeId, layout }) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `/BusTypeLayout/updateBusTypeLayout`,
            { busTypeId, layout },
            { headers: { Authorization: localStorage.getItem("JwtToken") } }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => console.log(err));
      });
    },
  },
};
